import { render, staticRenderFns } from "./EtsyInventories.vue?vue&type=template&id=38d144c2&scoped=true&"
import script from "./EtsyInventories.vue?vue&type=script&lang=js&"
export * from "./EtsyInventories.vue?vue&type=script&lang=js&"
import style0 from "./EtsyInventories.vue?vue&type=style&index=0&id=38d144c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d144c2",
  null
  
)

export default component.exports